import React from 'react';

import { RichTextBlockData } from 'api/cms';
import { RichText } from 'components/Text';

type Props = {
  blockIndex: number;
  data: RichTextBlockData;
  fullWidthLayout?: boolean;
  isSidebar?: boolean;
};

export function RichTextBlock({
  blockIndex,
  data: { html },
  fullWidthLayout,
  isSidebar,
}: Props) {
  return (
    <RichText
      dangerouslySetInnerHTML={{
        __html: html,
      }}
      textAlign={fullWidthLayout && 'center'}
      small={isSidebar}
      analyticsData={{
        eventName: 'CMS Block',
        eventProperties: {
          block_position: blockIndex,
          block_type: 'Rich Text',
        },
      }}
    />
  );
}
